import { render, staticRenderFns } from "./FitnessDeclarations.vue?vue&type=template&id=463e9286&"
import script from "./FitnessDeclarations.vue?vue&type=script&lang=js&"
export * from "./FitnessDeclarations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports